import { render, staticRenderFns } from "./addProductDialogStep4.vue?vue&type=template&id=394b5268&scoped=true&"
import script from "./addProductDialogStep4.vue?vue&type=script&lang=js&"
export * from "./addProductDialogStep4.vue?vue&type=script&lang=js&"
import style0 from "./addProductDialogStep4.vue?vue&type=style&index=0&id=394b5268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b5268",
  null
  
)

export default component.exports